import { ApolloLink, from } from '@apollo/client';
import {
  getG11nAndTranslationsFromServer,
  getG11nDataFromHeaders,
  initializeApolloClient,
  type TCustomGetServerSideProps,
} from '@crehana/next';

import { COURSE_DETAIL_PAGE_KEY } from '../constants';
import locales from '../i18n';
import { isValidQueryParams } from '../utils';

const getServerSideProps: TCustomGetServerSideProps = async ({
  req,
  query,
}) => {
  if (!isValidQueryParams(query)) {
    console.error('Invalid query (404)', query);

    return {
      notFound: true,
    };
  }

  const { countryCode } = getG11nDataFromHeaders(req.headers);

  const apolloClient = initializeApolloClient({
    headers: req.headers,
    pageKey: COURSE_DETAIL_PAGE_KEY,
    countryCode,
  });

  apolloClient.setLink(
    from([
      new ApolloLink((operation, forward) => {
        const uniqueId = new Date().getTime();
        const requestId = `${uniqueId} Request ${operation.operationName}`;
        console.time(requestId);
        return forward(operation).map(result => {
          console.timeEnd(requestId);
          console.info(
            'Response',
            operation.operationName,
            (operation.getContext()?.response as Response).status,
            (operation.getContext()?.response as Response).url,
          );
          return result;
        });
      }),
      apolloClient.link,
    ]),
  );

  const g11nData = await getG11nAndTranslationsFromServer({
    headers: req.headers,
    pageKey: COURSE_DETAIL_PAGE_KEY,
    defaultTranslations: locales,
    apolloClient,
  });

  return {
    props: {
      ...g11nData,
      renderCookiesBanner: true,
      orgSlug: query.orgSlug,
      contentSlug: query.contentSlug,
      organizationSlug: query.orgSlug,
    },
  };
};

export default getServerSideProps;
